import { parseAsString, useQueryState } from 'nuqs';
import { useContext, useState } from 'react';

import { StaticTextContext } from '@/components/context/StaticTextProvider';

export const useLevel = (levels) => {
  const { st } = useContext(StaticTextContext);

  const [level, setLevel] = useQueryState(
    st('level.key'),
    parseAsString.withDefault(''),
  );

  const [selectedLevel, setSelectedLevel] = useState(
    levels.find((l) => l.slug === (level === '' ? null : level)),
  );

  const onLevelChange = (currentLevel) => {
    setSelectedLevel(currentLevel);
    setLevel(currentLevel.id);
  };

  return { selectedLevel, onLevelChange };
};
